module.exports = __webpack_public_path__ + "img/20191009160505731.77aca5fa.jpg";